import { CaseFormData } from 'containers/pages/cases/types';

interface CaseFormAction {
	type: string;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	payload: any;
}

const caseFormReducer = (state: CaseFormData, action: CaseFormAction): CaseFormData => {
	switch (action.type) {
		case 'RESET':
		case 'CASE_CONVERT':
			return action.payload;
		case 'CLEAR_DEPENDENTS_CUSTOMER':
			return {
				...state,
				GroupId: null,
				GroupTitle: '',
				ProjectId: null,
				ProjectTitle: '',
				DeliverableId: null,
				DeliverableTitle: '',
				PrimaryContactId: null,
				PrimaryContactName: '',
			};
		case 'CLEAR_DEPENDENTS_GROUP':
			return {
				...state,
				ProjectId: null,
				ProjectTitle: '',
				DeliverableId: null,
				DeliverableTitle: '',
			};
		case 'CLEAR_DEPENDENTS_PROJECT':
			return {
				...state,
				DeliverableId: null,
				DeliverableTitle: '',
			};
		default:
			if (action.type in state) {
				return { ...state, [action.type]: action.payload };
			}
			return state;
	}
};

export default caseFormReducer;
